export const columnType = [
	'SEPARATION_READY_TO_DELIVERY',
	'WITHDRAWAL_FULFILLED_CHECK_IN',
	'WITHDRAWAL_FULFILLED_CHECK_OUT',
]
